"use client";
import { T } from "../theme";

// ─────────────────────────────────────────────────────────────────────
// PRIMITIVE COMPONENTS
// ─────────────────────────────────────────────────────────────────────
export function Btn({ children, onClick, v="primary", sz="md", full, style, disabled }) {
  const base = { cursor:disabled?"not-allowed":"pointer", display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8, fontWeight:700, border:"none", borderRadius:12, fontFamily:"inherit", transition:"all 0.18s", opacity:disabled?0.5:1, width:full?"100%":"auto", letterSpacing:0.1 };
  const S = { sm:{padding:"7px 16px",fontSize:13}, md:{padding:"11px 22px",fontSize:14}, lg:{padding:"14px 28px",fontSize:16}, xl:{padding:"16px 32px",fontSize:17} };
  const V = {
    primary:  {background:T.blue,   color:"#fff", boxShadow:"0 4px 14px rgba(8,145,178,0.35)"},
    navy:     {background:T.navy,   color:"#fff", boxShadow:"0 4px 14px rgba(15,23,42,0.3)"},
    outline:  {background:"transparent", border:"2px solid "+T.line, color:T.textS},
    ghost:    {background:"transparent", color:T.blue},
    cyan:     {background:T.cyan,   color:"#fff", boxShadow:"0 4px 14px rgba(6,182,212,0.35)"},
    success:  {background:T.green,  color:"#fff"},
    white:    {background:"#fff",   color:T.navy, boxShadow:"0 4px 14px rgba(0,0,0,0.1)"},
    "outline-white": {background:"transparent", border:"2px solid rgba(255,255,255,0.4)", color:"#fff"},
  };
  return (
    <button disabled={disabled} onClick={onClick}
      style={{...base, ...S[sz], ...V[v], ...style}}
      onMouseEnter={e=>{ if(!disabled){ e.currentTarget.style.filter="brightness(0.88)"; e.currentTarget.style.transform="translateY(-1px)"; }}}
      onMouseLeave={e=>{ e.currentTarget.style.filter="none"; e.currentTarget.style.transform="translateY(0)"; }}>
      {children}
    </button>
  );
}

export function Card({ children, style, className="" }) {
  return <div className={className} style={{ background:T.surface, borderRadius:18, border:"1px solid "+T.line, padding:24, boxShadow:"0 1px 4px rgba(0,0,0,0.05)", ...style }}>{children}</div>;
}

export function Badge({ label, color=T.blue, small, dot }) {
  return (
    <span style={{ background:color+"18", color, fontSize:small?10:12, fontWeight:700, padding:small?"2px 8px":"4px 12px", borderRadius:99, border:"1px solid "+color+"28", whiteSpace:"nowrap", display:"inline-flex", alignItems:"center", gap:5 }}>
      {dot && <span style={{width:6,height:6,borderRadius:"50%",background:color,flexShrink:0,animation:"pulse 2s ease infinite"}}/>}
      {label}
    </span>
  );
}

export function PBar({ value, color=T.blue, h=8 }) {
  return (
    <div style={{height:h, background:T.line, borderRadius:99, overflow:"hidden"}}>
      <div style={{height:"100%", width:Math.min(100,value)+"%", background:color, borderRadius:99, transition:"width 1.2s ease"}}/>
    </div>
  );
}